import React from 'react'
import type { PresentationBlock } from 'paintscout'

import { ButtonSelectOption, ButtonOption, StringOption } from '../../components'
import makeRowHandlers from '../../util/makeRowHandlers'

import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop'
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import LooksTwoIcon from '@material-ui/icons/LooksTwo'
import Looks3Icon from '@material-ui/icons/Looks3'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import AddIcon from '@material-ui/icons/Add'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

interface AwardsOptionsProps {
  block: PresentationBlock
  handleOptionFieldChange: (field: string, value: any) => void
}

function AwardsOptions(props: AwardsOptionsProps) {
  const { block, handleOptionFieldChange } = props
  const { alignment, columns, rows } = block.fields

  const { handleAddRow, handleRemoveLastRow } = makeRowHandlers({
    rows,
    newRow: { image: null, link: '' },
    handleOptionFieldChange
  })

  const linkOptions = (rows ?? []).map((row, index) => ({
    Component: (
      <StringOption
        key={index}
        label={`Image ${index + 1} Link`}
        value={row?.link ?? ''}
        onChange={(ev) => handleOptionFieldChange(`fields.rows[${index}].link`, ev.target.value)}
      />
    ),
    tab: 'content'
  }))

  const options = [
    {
      Component: (
        <ButtonSelectOption
          label={'Vertical Alignment'}
          value={alignment ?? 'middle'}
          buttons={[
            { icon: <VerticalAlignTopIcon />, value: 'top' },
            { icon: <VerticalAlignCenterIcon />, value: 'middle' },
            { icon: <VerticalAlignBottomIcon />, value: 'bottom' }
          ]}
          onChange={(value) => handleOptionFieldChange('fields.alignment', value)}
        />
      ),
      tab: 'content'
    },
    {
      Component: (
        <ButtonSelectOption
          label={'Columns'}
          value={columns ?? 'auto'}
          buttons={[
            { icon: <SettingsBackupRestoreIcon />, value: 'auto' },
            { icon: <LooksTwoIcon />, value: '2' },
            { icon: <Looks3Icon />, value: '3' }
          ]}
          onChange={(value) => handleOptionFieldChange('fields.columns', value)}
        />
      ),
      tab: 'content'
    },
    ...linkOptions,
    {
      Component: (
        <ButtonOption
          label={'Images'}
          buttons={[
            { icon: <AddIcon />, onClick: handleAddRow },
            ...(rows?.length ? [{ icon: <DeleteOutlineIcon />, onClick: handleRemoveLastRow }] : [])
          ]}
        />
      ),
      tab: 'content'
    }
  ]

  return options
}

export default AwardsOptions
